/**
 * Navigation Module
 * Handles view changes, routing, and UI state management
 */

export class NavigationManager {
  constructor(app) {
    this.app = app;
  }

  navigateToMenu() {
    if (!this.hasMenuData()) {
      return;
    }
    this.app.router.navigateTo('menu');
  }

  navigateToWelcome() {
    window.location.reload();
  }

  handleViewChange(viewName, data) {
    if (viewName === 'menu') {
      const welcomeContainer = document.querySelector('.welcome-container');
      if (welcomeContainer) {
        welcomeContainer.style.display = 'none';
      }

      const menuContainer = document.querySelector('.main-container');
      if (menuContainer) {
        menuContainer.style.display = '';
        menuContainer.style.visibility = 'visible';
      }

      setTimeout(() => {
        this.app.menuView.show();
        this.app.menuView.bindEvents();
      }, 100);
    } else if (viewName === 'welcome') {
      this.showWelcomeScreen();
    }
  }

  showWelcomeScreen() {
    const menuContainer = document.querySelector('.main-container');
    const welcomeContainer = document.querySelector('.welcome-container');

    if (menuContainer) {
      menuContainer.style.display = 'none';
      menuContainer.style.visibility = 'hidden';
    }

    if (welcomeContainer) {
      welcomeContainer.style.display = 'flex';
      welcomeContainer.style.visibility = 'visible';
      welcomeContainer.style.opacity = '1';
      welcomeContainer.style.height = '100vh';
      welcomeContainer.style.minHeight = '100vh';
      welcomeContainer.style.position = 'fixed';
      welcomeContainer.style.top = '0';
      welcomeContainer.style.left = '0';
      welcomeContainer.style.width = '100%';
      welcomeContainer.style.zIndex = '1000';
    }
  }

  refreshCurrentView() {
    const currentRoute = window.location.hash.slice(1) || 'welcome';

    if (currentRoute === 'welcome') {
      return;
    }

    if (currentRoute === 'menu' && this.app.menuView) {
      this.app.menuView.updateLanguage?.();
    }
  }

  hasMenuData() {
    const menuData = this.app.configManager?.getMenuData();
    return menuData &&
           menuData.categories &&
           menuData.categories.length > 0 &&
           menuData.items &&
           Object.keys(menuData.items).length > 0;
  }

  setTableNumber(tableNumber) {
    if (this.app.tableNumberBar) {
      this.app.tableNumberBar.setTableNumber(tableNumber);
    }
  }
}
